// Library Methods
import { useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";

// Components
import Grid from "@mui/material/Grid";
import GazeGraph from "../../../GazeGraph/GazeGraph";
import Alert from "src/components/shared/alerts/Alert/Alert";
import VFThresholdingChart from "./VFThresholdingChart/VFThresholdingChart";

// Contexts
import { ReportSectionContext } from "src/contexts/reports/ReportSectionContext";
import { ReportContext } from "src/contexts/reports/ReportContext";

// Utils
import {
  getGazeChartData,
  isTerminatedExamReport,
} from "src/utils/exams/examReportsHelper";

// Constants
import { examCardEnums } from "src/constants/enums";

const VFThresholdingGraph = () => {
  const { t } = useTranslation();

  const { exam } = useContext(ReportContext);
  const { examReport } = useContext(ReportSectionContext);

  const gazeSpots = useMemo(() => {
    const { gazeSpots } = getGazeChartData(examReport);
    return gazeSpots ?? [];
  }, [examReport]);

  const isTerminated = useMemo(
    () =>
      isTerminatedExamReport({
        exam,
        examReport,
        sectionName: examCardEnums.VISUAL_FIELD_THRESHOLDING.sectionName,
      }),
    [exam, examReport]
  );

  return (
    <Grid container gap="20px" id="vfthresholding-container">
      {isTerminated && (
        <Alert
          variant="error"
          alertContent={t("Terminated Exam")}
          props={{ width: "100%" }}
        />
      )}

      <Grid item xs={12} my="8px">
        <VFThresholdingChart isTerminated={isTerminated} />
      </Grid>
      <Grid item xs={12}>
        <GazeGraph gazeSpots={gazeSpots} />
      </Grid>
    </Grid>
  );
};

export default VFThresholdingGraph;
